export default __webpack_public_path__ + "static/media/girl@3x.3e0f893a.png";